type ExternalLinkOptions = {
  openInNewTab?: boolean;
};

const openExternalLink = async (targetURL: string, options?: ExternalLinkOptions) => {
  if (options?.openInNewTab && process.client) {
    try {
       const newWindow = window.open(targetURL, '_blank', 'noopener,noreferrer');
      return;
    } catch {
      // Fall back to same-tab navigation when popups are blocked.
    }
  }
  return await navigateTo(targetURL, { external: true });
};

export const useExternalLinkHandler = async (targetURL: string, options?: ExternalLinkOptions) => {
  if (!targetURL.startsWith('sso:')) {
    return await openExternalLink(targetURL, options);
  }

  const [, pid, page] = targetURL.split(':');
  try {
    const { data, error } = await useAPIHandler('get', '/auth/sso-urls', {
      query: { pid, page },
      auth: true
    });
    if (error) throw error;

    const externalLink = data.links.find((k: any) => k.page === page)?.url;
    if (!externalLink) throw new Error('External link not found');

    return await openExternalLink(externalLink, options);
  } catch (err) {
    console.error('Error fetching SSO link:', err);
    return navigateTo({ path: '/' });
  }
};
